import { ArrowUpRight } from "lucide-react";
import { POSTS } from "../data/site";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { CtaBlock } from "./About";

export default function Blog() {
  const featured = POSTS[0];
  const rest = POSTS.slice(1);
  return (
    <>
      <PageHero
        eyebrow="Insights"
        title={<>Field notes from the<br/><span className="text-[var(--primary)]">edge of industry.</span></>}
        subtitle="Engineering essays, project debriefs and honest commentary from the UMD team. No vendor fluff, no LinkedIn theatre — just what works."
        image="https://images.unsplash.com/photo-1488229297570-58520851e868?auto=format&fit=crop&w=1920&q=80"
      />

      {/* Featured */}
      <section className="py-16 md:py-24 container-wide">
        <Reveal>
          <a href="#" data-testid="blog-featured" className="grid md:grid-cols-12 gap-10 group">
            <div className="md:col-span-7 aspect-[16/10] overflow-hidden">
              <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="md:col-span-5 flex flex-col justify-center">
              <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[var(--primary)]">{featured.category} · {featured.date}</div>
              <h2 className="font-display text-3xl md:text-5xl leading-[1] tracking-tight mt-6">{featured.title}</h2>
              <p className="text-[var(--muted-fg)] mt-6 leading-relaxed">{featured.excerpt}</p>
              <div className="btn-ghost mt-8 self-start">Read article <ArrowUpRight size={14}/></div>
            </div>
          </a>
        </Reveal>
      </section>

      {/* Grid */}
      <section className="py-16 md:py-24 bg-[#fafafa]">
        <div className="container-wide">
          <div className="flex items-end justify-between mb-12">
            <h2 className="font-display text-3xl md:text-5xl leading-[1] tracking-tight">All articles</h2>
            <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[var(--muted-fg)]">{POSTS.length} posts</div>
          </div>
          <div className="grid md:grid-cols-3 gap-x-8 gap-y-16">
            {rest.map((p, i) => (
              <Reveal key={p.slug} delay={i * 60}>
                <a href="#" data-testid={`blog-card-${p.slug}`} className="group block">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-[var(--primary)] mt-6">{p.category} · {p.date}</div>
                  <h3 className="font-display text-xl md:text-2xl tracking-tight mt-3 leading-tight group-hover:text-[var(--primary)] transition-colors">{p.title}</h3>
                  <p className="text-sm text-[var(--muted-fg)] mt-3 leading-relaxed">{p.excerpt}</p>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBlock />
    </>
  );
}
